type TrackPayload = Record<string, any>;

export async function trackEvent(event: string, payload: TrackPayload = {}) {
  // 1) консоль (чтобы сразу видеть)
  try {
    // eslint-disable-next-line no-console
    console.log("[trackEvent]", event, payload);
  } catch {}

  // 2) пример "серверной аналитики" (если появится свой endpoint)
  // Сейчас безопасно: просто не ломает сайт, даже если endpoint не задан.
  try {
    // Поставь сюда свой URL, если нужно:
    // await fetch("/analytics/track", { ... })
  } catch {}
}